import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { GenLayout } from "@ui";

interface ThankyouProps {}

const Thankyou: FC<ThankyouProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <GenLayout>
        <h2>{t("thankyou_header")}</h2>
        <p>{t("thankyou_description")}</p>
      </GenLayout>
    </>
  );
};

export default Thankyou;
